import { useAppDispatch } from 'store';

import CriticalNoCallModal from './critical-no-call-modal';

import type { FC } from 'react';
import type { ICriticalNoCallModalsProps } from './types';

const CriticalNoCallModals: FC<ICriticalNoCallModalsProps> = (props) => {
  const {
    idx,
    readingType,
    openCriticalNoCallModal,
    toggleOpenCriticalNoCall,
  } = props;

  const {
    activityActions: { updateAction },
  } = useAppDispatch();

  return (
    <>
      {openCriticalNoCallModal && (
        <CriticalNoCallModal
          isOpen={openCriticalNoCallModal}
          closeModal={toggleOpenCriticalNoCall}
          handleSubmit={(msg: string) => {
            updateAction({ idx, action: { message: msg } });
          }}
          readingType={readingType}
          type="min"
          idx={idx}
        />
      )}
    </>
  );
};

export default CriticalNoCallModals;
